import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import {
  Form, Button, Modal, Header, Icon, Message,
} from 'semantic-ui-react';

import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';

class VinBlacklistForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      expirationDate: null,
      vin: '',
      notes: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { vinBlacklist } = this.props;
    if (!isEmpty(vinBlacklist)) {
      const {
        id, expirationDate, vin, notes,
      } = vinBlacklist;

      this.setState({
        id,
        expirationDate,
        vin,
        notes,
      });
    }
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      action,
    } = this.props;

    const {
      errors,
      expirationDate: stateExpirationDate,
      vin: stateVin,
      notes: stateNotes,
      id: stateId,
    } = this.state;

    const date = isEmpty(stateExpirationDate)
      ? null
      : utcMoment(stateExpirationDate);

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onDateChangeHandler = field => newDate => {
      this.setState({ [field]: moment(newDate, 'YYYY-MM-DD HH:mm:ss') });
    };

    const validationRules = {
      vin: 'required',
    };

    const submitForm = () => {
      const {
        id, expirationDate, vin, notes,
      } = this.state;

      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState(prevState => ({ ...prevState, ...validation.errors }));
        return;
      }
      onSubmitHandler({
        id,
        expirationDate: dateTimeFormatted(utcMoment(expirationDate)),
        vin,
        notes,
      });
      this.setState(prevState => ({ ...prevState, ...validation.errors }));
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>
          {!stateId && 'Create New Vin Blacklist'}
          {stateId && 'Edit Vin Blacklist'}
        </Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Header size='small' color='blue' />
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.vin)}>
                  <label htmlFor='vin'>Vin</label>
                  <input
                    id='vin'
                    name='vin'
                    value={stateVin}
                    onChange={onChangeHandler('vin')}
                    readOnly={action === 'edit'}
                    className={action === 'edit' ? 'input-disabled' : ''}
                  />
                  {errors.vin && <span>{errors.vin}</span>}
                </Form.Field>
                <Form.Field>
                  <label htmlFor='expirationDate'>Expiration Date</label>
                  <DatePicker
                    id='expirationDate'
                    style={{ padding: '0', width: '100%' }}
                    selected={date}
                    onChange={onDateChangeHandler('expirationDate')}
                    showTimeSelect
                    timeFormat='HH:mm'
                    timeIntervals={15}
                    dateFormat='YYYY-MM-DD HH:mm:ss ZZ'
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='notes'>Notes</label>
                  <input
                    id='notes'
                    name='notes'
                    value={stateNotes}
                    onChange={onChangeHandler('notes')}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting
            && !stateId && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Create
              </Button>
          )}

          {!submitting
            && stateId && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Update
              </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

VinBlacklistForm.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  action: PropTypes.string,
  vinBlacklist: PropTypes.shape({
    id: PropTypes.number,
    expirationDate: PropTypes.string,
    vin: PropTypes.string,
    notes: PropTypes.string,
  }),
};

VinBlacklistForm.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
  action: 'new',
  vinBlacklist: {},
};

export default VinBlacklistForm;
